import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useFiardleLeaderboard(sortBy: string = 'wins') {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.fiardle.leaderboard(),
    queryFn: () =>
      api.getFiardleLeaderboard({
        sortBy: sortBy as 'wins' | 'winRate' | 'streak',
        limit: 50,
        offset: 0,
      }),
  });

  return {
    entries: data?.entries ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to fetch leaderboard' : null,
    refetch: () => {
      refetch();
    },
  };
}
